/*SYSTEM IMPORTS*/
import React from "react"
import c from "classnames"
import Link from "components/Link"
// import Logo from 'components/ui/Logo'
import Img from "components/Img"
import "./style"
import "./media"

// import BoltSystem from './images/bolt-system.svg'
import ActionWrapp from "components/ui/ActionWrapp"
import Btn from "components/ui/Btn"

import BtnIcons from "images/btn-icons.svg"

/*CORES*/
import AppCore from "cores/AppCore"
import ConnectReduxWith from "helpers/Redux/connectRedux"

/* CONSTANTS */
import * as AnalyticAction from "constants/AnalyticAction"
import { IsIsset } from "helpers/ValueTests"

const Footer = (props = {}) => {
    const {
        user = {},
        allow_video_consultation = 0,
        allow_chat_consultation = 0,
        has_moderator = false,
        settings: { landing_id }
    } = props

    const denied_consultation = React.useMemo(
        () => allow_chat_consultation == 0 && allow_video_consultation == 0,
        [allow_chat_consultation, allow_video_consultation]
    )

    const prodHost = `https://skin.expert`

    const getActionLink = (action = "chat") => {
        const { seo_alias } = user

        if (has_moderator && action !== "detail") {
            action = "moderator"
        }

        if (action === "detail") {
            return `/doctor/${seo_alias}?landing_id=${landing_id}&from=doctor_landing`
        }

        return `/doctor/${seo_alias}?action=${action}&landing_id=${landing_id}&from=doctor_landing`
    }

    const isDevEnv = () => {
        return (
            window.location.hostname.indexOf("dev") !== -1 ||
            window.location.hostname.indexOf("stage") !== -1
        )
    }

    const redirectToAction = (actionUrl) => {
        if (!isDevEnv()) {
            window.open(`${prodHost}${actionUrl}`, "_blank")
        } else {
            window.open(actionUrl, "_blank")
        }
    }

    const handleToChat = () => {
        AppCore.GoogleAnalytic.eventAnalytic(
            AnalyticAction.VRITE_TO_DOCTOR,
            AnalyticAction.FOOTER_BUTTON
        )

        const actionUrl = getActionLink("chat")

        redirectToAction(actionUrl)
    }

    const handleToVideoChat = () => {
        AppCore.GoogleAnalytic.eventAnalytic(
            AnalyticAction.VIDEOCALL_TO_DOCTOR,
            AnalyticAction.FOOTER_BUTTON
        )

        const actionUrl = getActionLink("video_chat")

        redirectToAction(actionUrl)
    }

    const handleToDoctor = () => {
        const actionUrl = getActionLink("detail")

        redirectToAction(actionUrl)
    }

    const ToDoctor = () => {
        const actionUrl = getActionLink("detail")

        let val = `${prodHost}${actionUrl}`

        if (isDevEnv()) {
            val = actionUrl
        }
        return val
    }

    return (
        <footer className={c("footer")}>
            {!denied_consultation && (
                <div className="container footer__container">
                    <div className="footer__body">
                        <div className="footer__action-label">
                            {AppCore.Interfaces.t(
                                "DoctorLanding.Ui.Footer.Index.TextAnswers"
                            )}
                        </div>

                        <ActionWrapp>
                            {allow_chat_consultation == 1 && (
                                <Btn
                                    className="btn-chat"
                                    onClick={handleToChat}
                                    image={<Img src={BtnIcons} div />}
                                >
                                    {AppCore.Interfaces.t(
                                        "DoctorLanding.Ui.Footer.Index.ButtonWriteInChat"
                                    )}
                                </Btn>
                            )}

                            {allow_video_consultation == 1 && (
                                <Btn
                                    className="btn-video"
                                    onClick={handleToVideoChat}
                                    image={<Img src={BtnIcons} div />}
                                >
                                    {AppCore.Interfaces.t(
                                        "DoctorLanding.Ui.Footer.Index.ButtonVideoCall"
                                    )}
                                </Btn>
                            )}
                        </ActionWrapp>
                    </div>
                </div>
            )}
            <div className="footer__bottom-panel">
                <div className="container">
                    <div className="copyright">
                        <div className="copyright-large-text">
                            © 2023 SKIN.EXPERT
                        </div>
                        <div className="copyright-text">
                            {AppCore.Interfaces.t(
                                "DoctorLanding.Ui.Footer.Index.TextCopyright"
                            )}
                        </div>
                    </div>

                    <div className="link-to-site">
                        {AppCore.Interfaces.t(
                            "DoctorLanding.Ui.Footer.Index.LinkInProfile"
                        )}{" "}
                        <Link className="link" to={ToDoctor()}>
                            skin.expert
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default ConnectReduxWith("settings")(Footer)
